import { Toaster as HotToaster } from 'react-hot-toast';

interface ToasterProps {
  position?: 'top-left' | 'top-center' | 'top-right' | 'bottom-left' | 'bottom-center' | 'bottom-right';
  reverseOrder?: boolean;
  gutter?: number;
  containerClassName?: string;
  toastOptions?: {
    duration?: number;
    style?: React.CSSProperties;
  };
}

export function Toaster({ 
  position = 'top-right',
  reverseOrder = false,
  gutter = 8,
  containerClassName = '',
  toastOptions = {}
}: ToasterProps) {
  return (
    <HotToaster
      position={position}
      reverseOrder={reverseOrder}
      gutter={gutter}
      containerClassName={containerClassName}
      toastOptions={{
        duration: 4000,
        style: {
          fontFamily: 'inherit',
          maxWidth: '400px',
          ...toastOptions.style,
        },
        ...toastOptions,
      }}
    />
  );
}

export default Toaster;